import { render } from "./EntriesList.vue?vue&type=template&id=1ba97044&scoped=true&lang=pug"
import script from "./EntriesList.vue?vue&type=script&lang=js"
export * from "./EntriesList.vue?vue&type=script&lang=js"

import "./EntriesList.vue?vue&type=style&index=0&id=1ba97044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba97044"]])

export default __exports__